import { MatchEventType } from 'shared/types/match-event';
import { Resolution } from 'modules/overlay-canvas/types';

export type AccessTypes = 'default' | 'public' | 'private';

export type VisibilityEnum = 'all' | 'hide' | 'admin' | 'designer' | 'superAdmin';

/** Типы табло — единственный список: из него выведен тип, по нему проверяют файлы и генератор шаблонов. */
export const BOARD_TYPES = ['static', 'events', 'carousel', 'tv'] as const;

export type BoardTypeEnum = (typeof BOARD_TYPES)[number];

const BOARD_TYPE_SET: ReadonlySet<string> = new Set(BOARD_TYPES);

/** Строка из чужих данных (файл, база) — известный тип табло. */
export function isBoardType(value: unknown): value is BoardTypeEnum {
  return typeof value === 'string' && BOARD_TYPE_SET.has(value);
}

export interface TemplateFilter {
  name?: string;
  access?: AccessTypes[];
  ownerId?: number;
  visibility?: VisibilityEnum[];
  id?: number;
}

export interface CreateTemplate {
  name: string;
  createStartBoard: boolean;
  sportType: string;
  ownerId?: number;
  resolution?: Resolution;
  access?: AccessTypes;
  visibility?: VisibilityEnum;
}

export interface CreateBoard {
  version?: string;
  objects: Object[];
  templateId: number;
  name: string;
  type?: BoardTypeEnum;
  events?: MatchEventType[];
  duration?: number;
  isFavorite?: boolean;
  order?: number;
}

export interface UpdateTemplate {
  id: number;
  name?: string;
  access?: AccessTypes;
  ownerId?: number;
  visibility?: VisibilityEnum;
  resolution?: Resolution;
  sportType?: string;
  likes?: number[];
  views?: number[];
}

export interface UpdateBoard {
  id: number;
  name?: string;
  version?: string;
  objects?: Object[];
  templateId?: number;
  isFavorite?: boolean;
  type?: BoardTypeEnum;
  events?: MatchEventType[];
  duration?: number;
  order?: number;
}

export interface CopyTemplate {
  ownerId?: number;
  templateId: number;
  resolution?: Resolution;
  name?: string;
}

export interface CopyBoard {
  name?: string;
  boardId: number;
  templateId?: number;
  version?: string;
  objects?: Object[];
  isFavorite?: boolean;
  type?: BoardTypeEnum;
  events?: MatchEventType[];
  duration?: number;
  order?: number;
}

export interface EnsureOwnerTemplates {
  ownerId: number;
  visibility?: VisibilityEnum[];
}
